import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import type { LLCheckboxElement } from '../../types';

interface Props {
  element: LLCheckboxElement;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function CheckboxElement({ element, checked, onChange, disabled }: Props) {
  const id = `ll-checkbox-${element.index}`;
  return (
    <div className="flex items-start gap-2">
      <Checkbox id={id} checked={checked} onCheckedChange={onChange} disabled={disabled} />
      <Label htmlFor={id} className="text-sm leading-snug cursor-pointer">
        {element.text}
      </Label>
    </div>
  );
}
